<div class="documentBox">
  <mat-card class="filter">
    <div class="sortview">
      <div class="sortby" *ngIf="AllCoreTouchesListShow">

        <mat-form-field>
          <mat-label>Filter by</mat-label>
          <mat-select  matInput (selectionChange)="onChangeSelectedType($event)">
            <mat-option *ngFor="let rel of TouchesTypeForFilter" [value]="rel.touchTypeID">
              {{rel.touchName}}
            </mat-option>
         </mat-select>         
        </mat-form-field>

      </div>
    </div>
    <div class="actbtn">      
      <button mat-flat-button color="primary" (click)="addTouch()">
        Add Activity
      </button>
      <!-- &nbsp;  &nbsp;
      <button mat-flat-button color="primary" (click)="addEmailAction()">
        Send Email
      </button> -->
    </div>
  </mat-card>

  <div class="touches_holder">

    <mat-card class="touches" *ngFor="let touch of AllCoreTouchesList">

      <app-touches-list [touch]="touch"  
      (editTouchEmmitter)="editTouch($event)"
      (deleteTouchEmmitter)="deleteTouch($event)"        
      ></app-touches-list>
    </mat-card>   

    <mat-card class="touches" *ngIf="AllCoreTouchesList==null && AllCoreTouchesListShow">
      <p> No Record Found</p>
     </mat-card>

  

  </div>
</div>




